module.exports = __webpack_public_path__ + "static/media/group-students.946792fc.xlsx";